import React, { useState, useEffect } from "react";
import NavBar from "../../../../Member/Navbar/Navbar";
import Stepper from "./Stepper";
import {
  Container,
  Row,
  Col,
  Modal,
  Form,
  Button,
  Alert as AlertControl,
} from "react-bootstrap";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ServiceAdmin from "../../Services/ServiceAdmin";
import { Link } from "react-router-dom";
import "./AddCabinetStyle.css";
const AddCabinet = () => {
  const [count, setCount] = useState(1);
  useEffect(() => {
    setCount(2);
  });

  //Modal
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [loading, setLoading] = useState(false);
  const HandelClick = () => {
    setMessage("fadili");
    setSeverity("warning");
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // Form Cabiner
  const currentUser = JSON.parse(sessionStorage.getItem("user"));
  const user = {
    id: currentUser && currentUser.id,
  };
  const [denomination, setDenomination] = useState("");
  const [address, setAddress] = useState("");
  const [tel, setTel] = useState("");
  const [patent, setPatent] = useState("");
  const [numRC, setNumRC] = useState("");
  const [rib, setRib] = useState("");
  const [ice, setIce] = useState("");
  const [banque, setBanque] = useState(" ");
  const [formeJuridique, setFormeJuridique] = useState("");

  // add Cabinet

  const HandleAddCabinet = (e) => {
    ServiceAdmin.addcabinet(
      denomination,
      address,
      tel,
      patent,
      numRC,
      rib,
      ice,
      banque,
      formeJuridique,
      user
    ).then(
      (res) => {
        if (
          res.data.message.toString() ===
          "les details du cabinet est ajouté avec succée"
        ) {
          setLoading(false);
          setMessage(res.data.message);
          setSeverity("success");
          setOpen(true);
          window.location.replace("/message");
        }
      },
      (error) => {
        setLoading(false);
        setMessage("Une erreur est produite lors de la création du cabinet");
        setSeverity("error");
        setOpen(true);
      }
      //   window.location.reload();
      //   window.location.replace("/message");
      // });
    );
  };
  //
  //console.log("state ---->", denomination);

  const [contorl, setControl] = useState(false);
  return (
    <>
      <Snackbar open={open} autoHideDuration={40000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <div>
        <NavBar />
        <Stepper count={count} />

        <Container className="addCabinet">
          <div className="card">
            <h6
              style={{
                marginTop: "27px",
                marginBottom: "18px",
                fontSize: "x-large",
                textAlign: "center",
              }}
            >
              Cabinet
            </h6>
            <Row>
              <Col lg={4}>
                <div className="profile-header mb-2">
                  <h3>
                    <span>Denomination :</span>
                  </h3>
                  <Form.Control
                    required
                    defaultValue={denomination}
                    onChange={(e) => {
                      setDenomination(e.target.value);
                      setControl(false);
                    }}
                  />
                </div>
                {contorl && (
                  <AlertControl variant="warning">
                    Le champ est obligatoire
                  </AlertControl>
                )}
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Patent :</span>
                  </h3>
                  <Form.Control
                    defaultValue={patent}
                    onChange={(e) => setPatent(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>NumRC :</span>
                  </h3>
                  <Form.Control
                    defaultValue={numRC}
                    onChange={(e) => setNumRC(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Forme Juridique :</span>
                  </h3>
                  <Form.Control
                    as="select"
                    custom
                    defaultValue={formeJuridique}
                    onChange={(e) => setFormeJuridique(e.target.value)}
                  >
                    <option>SARL</option>
                    <option>AUTRE</option>
                  </Form.Control>
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Rib :</span>
                  </h3>
                  <Form.Control
                    defaultValue={rib}
                    onChange={(e) => setRib(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Banque :</span>
                  </h3>
                  <Form.Control
                    as="select"
                    custom
                    defaultValue={banque}
                    onChange={(e) => setBanque(e.target.value)}
                  >
                    <option>BMCI</option>
                    <option>BMCE</option>
                    <option>GFI</option>
                  </Form.Control>
                </div>
              </Col>

              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Ice :</span>
                  </h3>
                  <Form.Control
                    defaultValue={ice}
                    onChange={(e) => setIce(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Adress :</span>
                  </h3>
                  <Form.Control
                    defaultValue={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Téléphone :</span>
                  </h3>
                  <Form.Control
                    defaultValue={tel}
                    onChange={(e) => setTel(e.target.value)}
                  />
                </div>
              </Col>
              <Row style={{ width: "100%" }}>
                {/* <Link to="/message"> */}
                <Button
                  className="btn"
                  variant="primary"
                  onClick={() =>
                    denomination ? HandleAddCabinet() : setControl(true)
                  }
                  style={{
                    margin: "10px auto",
                    width: "160px",
                  }}
                >
                  Ajouter
                </Button>
                {/* </Link> */}
              </Row>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default AddCabinet;
